import { postJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_URL } from '../config/settings/environment'
import factoryAuthService from '../modules/requests/services'

/**
 * Comparators Traded's Amounts: Get the Comparator's Traded Amounts
 */
export const createComparatorTraded = factoryAuthService(({ year, idEntity }) => {
  const body = { idEntity, year }

  return postJsonRequest(`${REACT_APP_API_BASE_URL}/v1/calculo/comparator`, { body })
})

/**
 * Comparators Buying's Modalities: Get the Comparator Buying's Modalities
 */
export const createBuyingModalities = factoryAuthService(({ year, idEntity }) => {
  const body = { idEntity, years: year }

  return postJsonRequest(`${REACT_APP_API_BASE_URL}/v1/modalidad/compraComparator`, { body })
})

/**
 * Comparators Biddings: Get the Comparator Bidding's amounts
 */
export const createComparatorBiddings = factoryAuthService(({ year, idEntity }) => {
  const body = { idEntity, years: year }

  return postJsonRequest(`${REACT_APP_API_BASE_URL}/v1/sankey/sankeyComparator`, { body })
})

/**
 * Comparator's Traded By: Get all The Sectors between two Providers
 */
export const getSectorsByProviders = factoryAuthService(({ year, idEntity }) => {
  const body = { idEntity, year }

  return postJsonRequest(`${REACT_APP_API_BASE_URL}/v1/getTreeMap/listComparator`, { body })
})

/**
 * Comparator's Traded By: Get Amounts from Providers by Sector and Year
 */
export const createComparatorTradedBy = factoryAuthService(({ year, idEntity, category }) => {
  const body = { idEntity, year, idCategory: category }

  return postJsonRequest(`${REACT_APP_API_BASE_URL}/v1/getTreeMap/categoryComparator`, { body })
})

/**
 * Comparators Providers: Get the Comparator Providers's amounts
 */
export const createComparatorProviders = factoryAuthService(({ year, idEntity }) => {
  const body = { idEntity, year }

  return postJsonRequest(`${REACT_APP_API_BASE_URL}/v1/calculoMontoProveedor/getMontoProveedoresPorTamanoComparator`, {
    body
  })
})
